<div
  class="bg-gray-900 rounded-full text-white text-center uppercase"
  [style.width.px]="size"
  [style.height.px]="size"
  [style.font-size.px]="size * 0.4"
  [style.line-height.px]="size"
>
  {{ getInitials() }}
</div>
